import { convertDateToUTC } from './convert-date-to-utc'
import { FORMAT_LOCALE } from './locale'

export const formatDateShort = (value: string | Date) =>
  new Intl.DateTimeFormat(FORMAT_LOCALE, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(convertDateToUTC(new Date(value)))
